import { Controller } from '@hotwired/stimulus';
import { useClickOutside } from 'stimulus-use';

export default class extends Controller {
  static targets = ['form', 'content', 'input', 'result', 'loading'];

  connect() {
    useClickOutside(this);
  }

  disconnect() {
    this.cancelSearch();
  }

  clickOutside(event) {
    if (event.target.id !== 'show_all_link') {
      this.closeSearch();
    }
  }

  search(ev) {
    ev.preventDefault();
    this.cancelSearch();

    if (ev.type === 'submit') {
      let path = this.getUrl(this.inputTarget.value, true);

      if (this.formTarget.dataset.searchId !== undefined) {
        path += `&search_id=${this.formTarget.dataset.searchId}`;
      }

      window.location.href = path;
    } else {
      this.contentTarget.innerHTML = this.getLoadingHTML();

      this.searchTimer = setTimeout(() => {
        this.fetchSearch(this.inputTarget.value);
      }, 500);
    }
  }

  async searchAll(ev) {
    ev.preventDefault();

    this.contentTarget.innerHTML = this.getLoadingHTML();

    await this.fetchSearch(this.inputTarget.value, true);
  }

  showSearchBox() {
    this.contentTarget.style.display = 'block';
    const body = document.getElementsByTagName('BODY')[0];
    body.classList.add('dropdown-opened');

    this.contentTarget.innerHTML = this.getLoadingHTML();

    this.fetchSearch(this.inputTarget.value);
  }

  async fetchSearch(searchText = '', getAll = false) {
    this.cancelSearch();
    const url = this.getUrl(searchText, getAll);
    const requestController = new AbortController();
    this.requestController = requestController;

    try {
      const response = await fetch(url, { signal: requestController.signal });
      const responseHTML = await response.text();

      if (requestController.signal.aborted) return;

      if (response.url.includes('users/sign_in')) {
        window.location = response.url;
        return;
      }

      this.contentTarget.innerHTML = responseHTML;
    } catch (error) {
      if (!requestController.signal.aborted) throw error;
    } finally {
      if (this.requestController === requestController) {
        this.requestController = null;
      }
    }
  }

  cancelSearch() {
    clearTimeout(this.searchTimer);
    this.requestController?.abort();
  }

  closeSearch() {
    this.cancelSearch();
    this.inputTarget.blur();

    this.contentTarget.style.display = 'none';

    this.contentTarget.innerHTML = '';

    const body = document.getElementsByTagName('BODY')[0];
    body.classList.remove('dropdown-opened');
  }

  getLoadingHTML() {
    return `<div class='overlay'></div>
            <div class='portal portal--search'>
              <div class='search__result'>
                <h3 class='search__result-title'>Loading...</h3>
              </div>
            </div>`;
  }

  getUrl(searchText = '', getAll = false) {
    let params = new URLSearchParams();
    params.append('q', searchText);
    params.append('get_all', getAll);
    return `${this.formTarget.action}?${params}`;
  }
}
